import * as React from 'react';
import { createFileRoute, Outlet, Link, useRouterState } from '@tanstack/react-router';
import { cn } from '@/lib/cn';
import { useBrief } from '@/lib/brief';

export const Route = createFileRoute('/_app/brief')({
  staticData: { crumb: 'Treść strony' },
  component: BriefLayout,
});

type SectionLink = { to: string; label: string; exact?: boolean };
const SECTIONS: readonly SectionLink[] = [
  { to: '/brief', label: 'Dane podstawowe', exact: true },
  { to: '/brief/team', label: 'Zespół' },
  { to: '/brief/services', label: 'Usługi' },
  { to: '/brief/faq', label: 'FAQ' },
  { to: '/brief/testimonials', label: 'Opinie' },
  { to: '/brief/identity', label: 'O klinice' },
  { to: '/brief/equipment', label: 'Sprzęt' },
  { to: '/brief/accreditations', label: 'Akredytacje' },
];

function BriefLayout() {
  const { isPending } = useBrief();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <div className="grid gap-8 lg:grid-cols-[14rem_minmax(0,1fr)]">
      <aside>
        <p className="px-2 pb-3 text-xs font-medium uppercase tracking-wide text-text-subtle">
          Sekcje treści
        </p>
        <nav aria-label="Sekcje treści" className="flex flex-col gap-0.5">
          {SECTIONS.map((s) => {
            const active = s.exact ? pathname === s.to : pathname.startsWith(s.to);
            return (
              <Link
                key={s.to}
                // The route tree may not yet contain stubs for sub-pages we
                // haven't built; render as inactive when target is unknown.
                to={s.to as never}
                className={cn(
                  'rounded-md px-3 py-2 text-sm transition-colors',
                  active
                    ? 'bg-bg text-text font-medium shadow-[0_1px_2px_rgba(0,0,0,0.04)] ring-1 ring-black/5'
                    : 'text-text-muted hover:bg-bg/60 hover:text-text'
                )}
              >
                {s.label}
              </Link>
            );
          })}
        </nav>
      </aside>

      <div>
        {isPending ? (
          <div className="grid h-64 place-items-center text-sm text-text-muted">Ładowanie…</div>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
}
